/**
 * @fileoverview The founders' free-until day as the gardener reads it, with its year
 * ("June 30, 2027"; "30 de junio de 2027"). One home for the header, the
 * subscribe page, the plan card, the claim toast and the landing page.
 *
 * Where: everything that shows founding.FREE_UNTIL (the server sends the day).
 * API: none.
 * Words: none of its own; the day is Luxon's, in the app's language.
 *
 * @module foundingDay
 */

import { DateTime } from 'luxon';

/**
 * A founding free-until day, or a moment on it, as month, day and year in the app's language.
 *
 * @param day - A YYYY-MM-DD day or an ISO moment from the server.
 * @param language - The app's language.
 * @returns The day with its year, or '' when there is none or it does not read.
 */
export function foundingDay(day: string | null | undefined, language: string): string {
  if (!day) return '';
  const at = DateTime.fromISO(day);
  return at.isValid ? at.setLocale(language).toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' }) : '';
}
